import { EventDates } from "./types";
import { format, addDays, parse } from "date-fns";
import { DateUtils } from "react-day-picker";

export function getSelectedAndAvailableDates(dates: EventDates) {
  const liveEventSecondDays: Array<[string, number]> = Object.entries(
    dates.liveEvents,
  ).map(([date, amount]) => [
    format(addDays(parse(date, "MM/dd/yyyy", new Date()), 1), "MM/dd/yyyy"),
    amount,
  ]);

  const { availableDates, soldOutDates } = [
    ...Object.entries(dates.liveEvents),
    ...liveEventSecondDays,
    ...Object.entries(dates.exams),
  ].reduce<{
    availableDates: Array<[Date, number]>;
    soldOutDates: Array<[Date, number]>;
  }>(
    (obj, entry) => {
      const [dateString, amount] = entry;
      const date = parse(dateString, "MM/dd/yyyy", new Date());

      if (
        amount < 20 &&
        !DateUtils.isSameDay(date, new Date("5/10/2023")) &&
        !DateUtils.isSameDay(date, new Date("5/11/2023")) &&
        !DateUtils.isSameDay(date, new Date("04/19/2025")) &&
        !DateUtils.isSameDay(date, new Date("07/10/2025")) &&
        !(DateUtils.isPastDay(date) || DateUtils.isSameDay(date, new Date())) &&
        !(
          liveEventSecondDays.find(([date]) => date === dateString) &&
          DateUtils.isSameDay(date, addDays(new Date(), 1))
        )
      ) {
        obj.availableDates.push([date, amount]);
      } else {
        obj.soldOutDates.push([
          parse(dateString, "MM/dd/yyyy", new Date()),
          amount,
        ]);
      }
      return obj;
    },
    { availableDates: [], soldOutDates: [] },
  );
  return { liveEventSecondDays, availableDates, soldOutDates };
}
